/* The Vue build version to load with the `import` command */
/* (runtime-only or standalone) has been set in webpack.base.conf with an alias. */
import './lib/css'
import './lib/script'
/* import './lib/global' */

import Vue from 'vue'
import App from './App'
import router from './router'
import EventBus from './lib/eventBus.js'
import constants from './assets/js/constants.js'
import Loading from 'vue-loading-overlay'
import moment from 'moment/moment.js'
import 'vue-loading-overlay/dist/vue-loading.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueCarousel from 'vue-carousel'
import VueCurrencyFilter from 'vue-currency-filter'
import VModal from 'vue-js-modal'

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/images/marker-shadow.png'

// VM - FIX para URLs mal codificadas (Vue Router legacy)
const _decode = decodeURIComponent
window.decodeURIComponent = function (value) {
  try {
    return _decode(value)
  } catch (e) {
    return value
  }
}

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

Vue.use(VModal, { dynamic: true })

Vue.prototype.$bus = EventBus

Vue.use(Loading, {
  color: constants.colorPalette.baseBlue
})

Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

Vue.use(VueCarousel)

Vue.filter('formatFirstLetter', function (value) {
  if (typeof value !== 'string') {
    return value
  }
  value = value.toLocaleLowerCase()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('formatAmount', function (value) {
  if (typeof value !== 'number') {
    return value
  }

  return new Intl.NumberFormat('es-pe').format(value)
})

Vue.filter('formatPercentage', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('es-pe', {
    style: 'decimal',
    minimumFractionDigits: 2
  })

  return formatter.format(value)
})

Vue.filter('formatDecimal', function (value) {
  if (typeof value !== 'number') {
    return value
  }

  return String(parseFloat(Math.round(value * 100) / 100).toFixed(2)).replace('.', ',')
})

Vue.filter('formatMiles', function (value) {
  if (typeof value !== 'number') {
    return value
  }

  let _out = value // parseFloat(Math.round(value * 100) / 100).toFixed(2)

  if (_out > 1000) {
    _out = _out / 1000
    return String((parseFloat(Math.round(_out * 100) / 100).toFixed(2))).replace('.', ',') + 'K'
  } else {
    return String(parseFloat(Math.round(_out * 100) / 100).toFixed(2)).replace('.', ',')
  }
})

Vue.filter('formatDate', function (value, format, iftable) {
  if (value) {
    if (iftable) {
      return moment(String(value)).add(1, 'day').locale('es-pe').format(format)
    }
    return moment(String(value)).locale('es-pe').format(format)
  }
})

Vue.filter('formatDateOnly', function (value, format, iftable) {
  if (value) {
    if (iftable) {
      return moment(String(value)).format(format)
    }
    return moment(String(value)).format(format)
  }
})

Vue.filter('formatWeightKg', function (value, precision) {
  let isNumber = !isNaN(+value) && isFinite(value)

  if (!(!isNaN(+precision) && isFinite(precision))) precision = 2

  let _out = value
  if (isNumber) {
    _out = value.toFixed(precision) + ' Kg'
  }

  return _out
})

Vue.filter('formatVolM', function (value, precision) {
  let isNumber = !isNaN(+value) && isFinite(value)

  if (!(!isNaN(+precision) && isFinite(precision))) precision = 2

  let _out = value
  if (isNumber) {
    if (value > 1) {
      _out = value.toFixed(precision) + ' m³'
    } else {
      _out = (value).toFixed(precision) + ' m³'
    }
  }

  return _out
})

Vue.filter('formatVolM1', function (value, precision) {
  let isNumber = !isNaN(+value) && isFinite(value)

  if (!(!isNaN(+precision) && isFinite(precision))) precision = 2

  let _out = value
  if (isNumber) {
    if (value > 1) {
      _out = value.toFixed(precision) + ' m³'
    } else {
      _out = (value).toFixed(precision) + ' m³'
    }
  }

  return _out
})

Vue.use(VueGoogleMaps)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js